// Before a search the live temperature graph is shown, so its legend applies.
export const chartLegend = (isReadyToRender, chartOption) => ({
  option: isReadyToRender
    ? Boolean(chartOption?.[0] || chartOption?.[1])
    : true,
  graph: chartOption?.[3] ? 'data' : 'energy',
});
